import {
	IPortFormData,
	IFilterFormData,
	IOwnershipFormData,
	IPortfolioFormData,
	IVesselFormData,
	ISectorFormData,
	TOutputType,
	TSelectionType,
} from '../../shared/sharedTypes';

export type TSearchState = {
	isBusy: boolean;
	selectionType: TSelectionType;
	selectionName: string;
	// selectedVessels?: TSubscribedMsiVessel[] | [];
	selectedVesselsList?: IVesselFormData[] | [];
	selectionTypeObject?: IPortFormData | IVesselFormData | IPortfolioFormData | IFilterFormData | IOwnershipFormData | ISectorFormData;
	outputType: TOutputType;
};

// export type TSelectionType = 'Vessel' | 'Filter' | 'Portfolio' | 'Ownership' | 'Draft' | undefined;

export interface IRecentSearchForm {
	type?: string | 'Port' | 'Vessel' | 'Portfolio' | 'Filter' | 'Ownership' | 'Sector';
	id?: number;
	imoNumber?: number;
	name: string;
	country?: string;
	sector?: string;
	scope?: string;
	isOwnPortfolio?: boolean;
	isOwnFilter?: boolean;
	isDraft?: boolean;
}

export interface ISearchDataForm {
	ports: any[] | null; // This will be handled by the port module
	vessels: IVesselSearchForm[] | null;
	portfolios: IPortfolioSearchForm[] | null;
	filters: IFilterSearchForm[] | null;
	ownerships: IOwnershipSearchForm[] | null;
	sectors: ISectorSearchForm[] | null;
}

export interface IPortfolioSearchForm {
	id: number;
	name: string;
	scope: string;
	isOwnPortfolio: boolean;
}

export interface IFilterSearchForm {
	id: number;
	name: string;
	scope: string;
	isOwnFilter: boolean;
}

export interface IVesselSearchForm {
	imoNumber: number;
	name: string;
	sector: string;
	companyName: string;
}

export interface IOwnershipSearchForm {
	name: string;
}

export interface ISectorSearchForm {
	name: string;
}

export enum ScopeOptions {
	Personal = 'Personal',
	Team = 'Team',
}

// export enum TOutputType {
// 	Vessel = 'Vessel',
// 	Fleet = 'Fleet',
// 	Summary = 'Summary',
// 	// Draft = 'Draft',
// 	None = 'None'
// }

export type TSelectedVesselData = {
	vesselList: IVesselSearchForm[];
	selectionType: TSelectionType;
	selectionName: string;
};

// Slice name in the ...Slice.ts file
export const SEARCH = 'search';

